import React, { memo } from 'react';
import { useRouter } from 'next/router';
import type { CSS } from '@components-shared/src/stitches';
import { Button } from '@components/main-components/button/Button';
import { DisplayToggle } from '@components/shared';
import { triggerLogin } from '@context/auth/store';
import { trackClickEvent } from '@lib/analytics';
import { useHeaderStore } from '@store/header';
import { BLUR_BACKGROUND_PATHS } from '@utils/constants';

export const ConnectWallet = memo(function ConnectWallet({
  css,
  variant,
  loading,
}: {
  css?: CSS;
  variant: 'desktop' | 'mobile';
  loading: boolean;
}) {
  const { pathname } = useRouter();

  const { close } = useHeaderStore();

  const onClick = () => {
    trackClickEvent({
      event: 'Sign in Clicked',
      properties: {
        sourceComponent: 'Navigation',
      },
    });
    close();
    triggerLogin();
  };

  const isBlurBackground = BLUR_BACKGROUND_PATHS.includes(pathname);

  return (
    <>
      <DisplayToggle media="tablet">
        <Button
          deprecatedCSS={css}
          size={variant === 'mobile' ? 'L' : 'M'}
          fullWidth
          variant={isBlurBackground ? 'tertiary' : 'primary'}
          label="Sign in"
          onClick={onClick}
          loading={loading}
        />
      </DisplayToggle>
      <DisplayToggle media="notTablet">
        <Button
          deprecatedCSS={css}
          size={variant === 'mobile' ? 'L' : 'M'}
          fullWidth
          variant="primary"
          label="Sign in"
          onClick={onClick}
          loading={loading}
        />
      </DisplayToggle>
    </>
  );
});
